<div class="popup passwordChangePopup">
    <button class="close-button" (click)="close()"></button>
    <div class="passwordChangePopup-content">
        <div class="passwordChangePopup-content-img"></div>
        <h2 class="passwordChangePopup-content-title _primary"[i18nKey]="'popup.change.password.title'"></h2>
        <p class="passwordChangePopup-content-description" [i18nKey]="descriptionKey"></p>
        <label class="_fullWidth">
            <span [i18nKey]="'popup.change.password.current.password'"></span>
            <input type="password" [(ngModel)]="currentPassword" required/>
        </label>
        <kiwi-spacer [size]="8"></kiwi-spacer>
        <label class="_fullWidth">
            <span [i18nKey]="'popup.change.password.new.password'"></span>
            <!--
                Verification about the minimum length of the password is only done in the front
                because passwords are encrypted before sending them to the back
            -->
            <input name="newPassword"
                   type="password"
                   [(ngModel)]="newPassword"
                   minlength="6"
                   aria-descirbedby="newPasswordHelpText" required/>
            <p class="help-text _error" id="passwordHelpText" *ngIf="newPassword.length < 6 && newPassword !== ''" [i18nKey]="'popup.change.password.new.password.min.length.error'"></p>
        </label>
        <kiwi-spacer [size]="24"></kiwi-spacer>
        <button class="button"
                (click)="onConfirm()"
                [disabled]="currentPassword == '' || newPassword == '' || newPassword.length < 6" [i18nKey]="'common.action.confirm'"></button>
    </div>
</div>
<div class="overlay"></div>
